<template>
  <div class="trigger trigger-section">
    <div class="trigger-section-header trigger-section-header-orange">
      <b-icon icon="exclamation-triangle-fill" />
      <span>{{ $t('configuracao-dos-gatilhos-dos-limites') }}</span>
    </div>
    <div class="trigger-section-body">
      <div class="trigger-cards-row">

        <!-- VLV: Limite de Valor -->
        <div v-if="!isRta" class="trigger-card" :class="{ 'trigger-card--inactive': !vlvActive }">
          <div class="trigger-card-header">
            <b-form-checkbox id="limit-value" v-model="vlvActive" @change="sendVLV" class="trigger-checkBox" name="limit-value" value=true switch :title="$t('limite-de-valor')" v-marquee-overflow>
              {{ $t('limite-de-valor') }}
            </b-form-checkbox>
            <b-icon v-if="!show" @click="() => showInfo(triggerInfo.VLV.title + ' - ' + triggerInfo.VLV.description)" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
            <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary', content: triggerInfo.VLV.title + ' - ' + $t('explicacao-fca-1') }" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
          </div>
          <div class="trigger-card-content">
            <span class="trigger-field">
              <input type="checkbox" class="trigger-sm-check" v-model="minActive" @change="sendVLV" />
              <span>{{ $t('minimo') }}</span>
              <b-form-input type="number" v-model="minValue" @keyup="sendVLV" @change="sendVLV" placeholder="0" style="width: 60px;" />
            </span>
            <span class="trigger-field">
              <input type="checkbox" class="trigger-sm-check" v-model="maxActive" @change="sendVLV" />
              <span>{{ $t('maximo') }}</span>
              <b-form-input type="number" v-model="maxValue" @keyup="sendVLV" @change="sendVLV" placeholder="0" style="width: 60px;" />
            </span>
          </div>
        </div>

        <!-- VFR: Análises Fora da Meta -->
        <div class="trigger-card" :class="{ 'trigger-card--inactive': !vfrActive }">
          <div class="trigger-card-header">
            <b-form-checkbox id="checkbox-3" v-model="vfrActive" @change="sendVFR" class="trigger-checkBox" name="checkbox-3" value=true switch :title="$t('analises-fora-da-meta')" v-marquee-overflow>
              {{ $t('analises-fora-da-meta') }}
            </b-form-checkbox>
            <b-icon v-if="!show" @click="() => showInfo(triggerInfo.VFR.title + ' - ' + triggerInfo.VFR.description)" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
            <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary', content: triggerInfo.VFR.title + ' - ' + $t('explicacao-fca-2') }" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
          </div>
          <div class="trigger-card-content trigger-card-content--column">
            <div class="trigger-min-max-row">
              <span class="trigger-field trigger-field--tight">
                <input type="checkbox" class="trigger-sm-check" v-model="vfrMinActive" @change="sendVFR" />
                <span>{{ $t('minimo') }}</span>
                <b-form-input type="number" id="vfr-min" v-model="vfrMinValue" @keyup="sendVFR" @change="sendVFR"
                  placeholder="0" style="width: 50px;" :disabled="!vfrMinActive" />
              </span>
              <span class="trigger-field trigger-field--tight">
                <input type="checkbox" class="trigger-sm-check" v-model="vfrMaxActive" @change="sendVFR" />
                <span>{{ $t('maximo') }}</span>
                <b-form-input type="number" id="vfr-max" v-model="vfrMaxValue" @keyup="sendVFR" @change="sendVFR"
                  placeholder="100" style="width: 50px;" :disabled="!vfrMaxActive" />
              </span>
            </div>
            <span class="trigger-field">
              <label for="unit-frequency">{{ $t('nao-conformidades') }}</label>
              <b-form-input type="number" id="unit-frequency" v-model="unconformities" @keyup="sendVFR" @change="sendVFR"
                placeholder="1" @input="handleInput('unconformities', $event)" style="width: 50px;" min="1" />
            </span>
          </div>
        </div>

        <!-- VLT: Tempo Sem Atingir Meta -->
        <div v-if="!isRta" class="trigger-card" :class="{ 'trigger-card--inactive': !vltActive }">
          <div class="trigger-card-header">
            <b-form-checkbox id="checkbox-4" v-model="vltActive" @change="sendVLT" class="trigger-checkBox" name="checkbox-4" value=true switch :title="$t('tempo-sem-atingir-meta')" v-marquee-overflow>
              {{ $t('tempo-sem-atingir-meta') }}
            </b-form-checkbox>
            <b-icon v-if="!show" @click="() => showInfo(triggerInfo.VLT.title + ' - ' + triggerInfo.VLT.description)" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
            <b-icon v-if="show" v-b-popover.hover="{ variant: 'secondary', content: triggerInfo.VLT.title + ' - ' + $t('explicacao-fca-3') }" class="question-icon" icon="question-circle-fill" aria-hidden="true" />
          </div>
          <div class="trigger-card-content">
            <span class="trigger-field">
              <label for="minute-interval">{{ $t('intervalo') }}</label>
              <b-form-input type="number" id="minute-interval" v-model="minutes" @keyup="sendVLT" @change="sendVLT"
                placeholder="10" @input="handleInput('minutes', $event)" min="1" style="width: 60px;" />
              <label for="minute-interval">{{ show ? $t('days') : $t('minutos') }}</label>
            </span>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import MediatorTrigger from "../tools/MediatorTrigger";

export default {
  name: "TriggerLimitValue",
  props: ["triggerInfo", "reset", "triggerSelected", "show", "isRta"],
  inject: ["showInfo", "showResponsibles"],
  data() {
    return {
      vlvActive: false,
      minActive: false,
      minValue: 0,
      maxActive: false,
      maxValue: 0,

      vfrActive: false,
      unconformities: 1,
      vfrMinActive: false,
      vfrMinValue: 0,
      vfrMaxActive: false,
      vfrMaxValue: 100,

      vltActive: false,
      minutes: 1,
      updating: false,

      daysConverted: 0
    }
  },
  watch: {
    reset() {
      this.resetForm();
    },
  },

  methods: {
    loadForm(value) {
      if (!value.VLV) return
      this.updating = true;

      this.vlvActive = value.VLV.active;
      if (value.VLV.configurationJSON) {
        let configurationJSON = JSON.parse(value.VLV.configurationJSON)
        this.minActive = configurationJSON.minActive;
        this.minValue = configurationJSON.minValue;
        this.maxActive = configurationJSON.maxActive;
        this.maxValue = configurationJSON.maxValue;
      }

      this.vfrActive = value.VFR.active;
      if (value.VFR.configurationJSON) {
        let configurationJSON = JSON.parse(value.VFR.configurationJSON)
        this.unconformities = configurationJSON.unconformities;
        this.vfrMinActive = configurationJSON.minActive;
        this.vfrMinValue = configurationJSON.minValue;
        this.vfrMaxActive = configurationJSON.maxActive;
        this.vfrMaxValue = configurationJSON.maxValue;
      }

      this.vltActive = value.VLT.active;
      if (value.VLT.configurationJSON) {
        let configurationJSON = JSON.parse(value.VLT.configurationJSON)
        if(this.show){
          this.minutes = configurationJSON.minutes/1440;
        }else{
          this.minutes = configurationJSON.minutes;
        }
      }
    },

    sendVLV() {
      MediatorTrigger.notify({
        active: this.vlvActive,
        minActive: this.minActive,
        minValue: this.minValue,
        maxActive: this.maxActive,
        maxValue: this.maxValue,
      }, "setVLV")
    },

    sendVFR() {
      MediatorTrigger.notify({
        active: this.vfrActive,
        unconformities: this.unconformities,
        minActive: this.vfrMinActive,
        minValue: this.vfrMinValue,
        maxActive: this.vfrMaxActive,
        maxValue: this.vfrMaxValue
      }, "setVFR");
    },

    sendVLT() {
      if (this.show) 
      {
        this.daysConverted = (this.minutes * 1440)
        
        MediatorTrigger.notify({
          active: this.vltActive,
          minutes: this.daysConverted
        }, "setVLT")
      } else 
      {
        MediatorTrigger.notify({
          active: this.vltActive,
          minutes: this.minutes
        }, "setVLT")
      }
    },

    resetForm() {
      this.vlvActive = false;
      this.minActive = false;
      this.minValue = 0;
      this.maxActive = false;
      this.maxValue = 0;
      this.vfrActive = false;
      this.unconformities = 4;
      this.vfrMinActive = false;
      this.vfrMinValue = 0;
      this.vfrMaxActive = false;
      this.vfrMaxValue = 100;
      this.vltActive = false;
      
      if (this.show) 
      {
        this.minutes = 1;
      } else 
      {
        this.minutes = 10;
      }

      this.daysConverted = 0;
    },

    handleInput(prop, event) {
      let cleanedValue = event.replace(/\D/g, '');
      if (prop == 'unconformities')
        this.unconformities = cleanedValue !== '' ? parseInt(cleanedValue) : null;
      else
        this.minutes = cleanedValue !== '' ? parseInt(cleanedValue) : null;
    }
  },

  mounted() {
    console.log("TriggerValueLimit - isRta:", this.isRta);
    
    if (this.show) 
    {
      this.minutes = 1
    }

    MediatorTrigger.notify(this, "initTriggerValueLimit")
  },
}
</script>

<style scoped src="../style.css"></style>